import { createContext } from 'react';

const UserContext = createContext(void 0);

UserContext.displayName = 'context(User)';

export default UserContext;